// Copyright (c) 2022 by Move Closer

import { computed, ref } from '@vue/composition-api'
import { VueConstructor } from 'vue'

import { canHaveThemeProp } from '../../composables'
import { ComponentObjectPropsOptions, Emit } from '../../vue-api'

import { AlertProps, UseAlertContentProvides } from './Alert.contracts'
import { variantsIconRegistry } from './Alert.config'

/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export const alertProps: ComponentObjectPropsOptions<AlertProps> = {
  ...canHaveThemeProp,

  /**
   * @see AlertProps.closable
   */
  closable: {
    type: Boolean,
    required: false,
    default: true
  },

  /**
   * @see AlertProps.content
   */
  content: {
    type: String,
    required: false
  }
}

export const useAlert = (props: AlertProps, emit: Emit): UseAlertContentProvides => {
  const currentContent = ref<string | undefined>(props.content)

  /**
   * define type of icon from partials
   */
  const icon = computed<VueConstructor>(() => {
    if (!(props.theme in variantsIconRegistry)) {
      throw new Error('Icon type does not exist. Provide one name from: warning, danger, info, success.')
    }

    return variantsIconRegistry[props.theme]
  })

  const hasContent = computed<boolean>(() => {
    return typeof currentContent.value !== 'undefined'
  })

  /**
   * emit alert close event
   */
  const onClose = (): void => {
    currentContent.value = undefined

    emit('closed')
  }

  return { currentContent, icon, hasContent, onClose }
}
